///////////////////////////////////////////////////////////////////////////////////////////////////////////
// LIBRARY IMPORTS
///////////////////////////////////////////////////////////////////////////////////////////////////////////
import leafletPip from '@mapbox/leaflet-pip';

///////////////////////////////////////////////////////////////////////////////////
// CONSTANTS
///////////////////////////////////////////////////////////////////////////////////
let MAP, HOMEBOUNDS, PLACEMARKER;
let COUNTIES, CURRENT_ASSEMBLY, CURRENT_SENATE, FUTURE_ASSEMBLY, FUTURE_SENATE, INDIGENOUS;
const DEFAULT_CENTER = [ 36.778259, -119.417931]
const DEFAULT_ZOOM = 8;
const MAX_ZOOM = 18;
const LAYERS = {};

const COUNTY_STYLE = {color: '#FF8000', weight: 3, opacity: 0.5};
const NO_STYLE = {stroke: false, fill: false};

// Bing API key for geocoding
const BING_API_KEY = 'AjBuYw8goYn_CWiqk65Rbf_Cm-j1QFPH-gGfOxjBipxuEB2N3n9yACKu5s8Dl18N';

///////////////////////////////////////////////////////////////////////////////////
// DATA IMPORTS
///////////////////////////////////////////////////////////////////////////////////
import countyGeoJSON from '../static/data/bayareacounties.json';
import indigenousGeoJSON from '../static/data/indigenousTerritories_bayarea.json';
import currentAssemblyGeoJSON from '../static/data/current_assembly_bayarea.json';
import currentSenateGeoJSON from '../static/data/current_senate_bayarea.json';
import futureAssemblyGeoJSON from '../static/data/future_assembly_bayarea.json';
import futureSenateGeoJSON from '../static/data/future_senate_bayarea.json';

///////////////////////////////////////////////////////////////////////////////////
// STYLES
///////////////////////////////////////////////////////////////////////////////////
import styles from './index.scss';

///////////////////////////////////////////////////////////////////////////////////
// INITIALIZATION FUNCTIONS
///////////////////////////////////////////////////////////////////////////////////
$(document).ready(function() {
  initMap();
  initAddressSearch();
});

// basic map inits, layers
function initMap() {
  MAP = L.map('map', {
    maxZoom: MAX_ZOOM,
    doubleClickZoom: false,
    keyboard: true,
  });

  // add the one and only tile layer
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: "&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors",
  }).addTo(MAP);

  // ADD PLACE LAYERS HERE

  // add the counties to the map and keep a reference
  COUNTIES = L.geoJSON(countyGeoJSON, {
    style: COUNTY_STYLE,
    interactive: false,
  }).addTo(MAP);
  LAYERS['counties'] = {
    layer: COUNTIES,
    field: 'countyname',
    label: 'County',
  }

  // create the indigenous territories, and keep a reference
  INDIGENOUS = L.geoJSON(indigenousGeoJSON, {
    style: NO_STYLE,
    interactive: false,
  }).addTo(MAP);
  LAYERS['indigenous'] = {
    layer: INDIGENOUS,
    field: 'Name',
    label: 'Indigenous Territory'
  }

  // create the current assembly districts, and keep a reference
  CURRENT_ASSEMBLY = L.geoJSON(currentAssemblyGeoJSON, {
    style: NO_STYLE,
    interactive: false,
  }).addTo(MAP);
  LAYERS['current_assembly'] = {
    layer: CURRENT_ASSEMBLY,
    field: 'District',
    label: 'Current Assembly District'
  }

  // create the future assembly districts, and keep a reference
  FUTURE_ASSEMBLY = L.geoJSON(futureAssemblyGeoJSON, {
    style: NO_STYLE,
    interactive: false,
  }).addTo(MAP);
  LAYERS['future_assembly'] = {
    layer: FUTURE_ASSEMBLY,
    field: 'DISTRICT',
    label: 'Redistricted Assembly District'
  }

  // create the current senate districts, and keep a reference
  CURRENT_SENATE = L.geoJSON(currentSenateGeoJSON, {
    style: NO_STYLE,
    interactive: false,
  }).addTo(MAP);
  LAYERS['current_senate'] = {
    layer: CURRENT_SENATE,
    field: 'District',
    label: 'Current Senate District'
  }

  // create the future assembly districts, and keep a reference
  FUTURE_SENATE = L.geoJSON(futureSenateGeoJSON, {
    style: NO_STYLE,
    interactive: false,
  }).addTo(MAP);
  LAYERS['future_senate'] = {
    layer: FUTURE_SENATE,
    field: 'DISTRICT',
    label: 'Redistricted Senate District'
  }

  // fit the map to the COUNTIES
  MAP.fitBounds(COUNTIES.getBounds());

  // register the function that does the place lookup on click
  MAP.on('click', function(e) {
    getLayerNamesAtLatLng(e.latlng.lat, e.latlng.lng);
  });
}

function initAddressSearch() {
  $('#search-button').on('click', function() {
    const address = $('#search').val();

    // not a lat/lng, this is probably an address
    const url    = 'https://dev.virtualearth.net/REST/v1/Locations/?query=' + encodeURIComponent(address);
    const params = { output:'json', key: BING_API_KEY };

    // call bing
    $.ajax(url, {
      dataType: 'jsonp',
      jsonp: 'jsonp',
      crossDomain: true,
      data: params,
    }).fail(function(){
      Swal.fire({
        text: 'Could not find that address! Please try again',
        icon: 'error',
      });
    }).done(function(response) {
      // various attempts to trap errors: sometimes resouces comes back with nothing in it:
      if (!response.resourceSets.length) return Swal.fire({
        text: 'Could not find that address! Please try again',
        icon: 'error',
      });


      if (!response.resourceSets[0].resources.length) return Swal.fire({
        text: 'Could not find that address! Please try again',
        icon: 'error',
      });

      if (!response.resourceSets[0].resources[0]) return Swal.fire({
        text: 'Could not find that address! Please try again',
        icon: 'error',
      });
      let latlng = response.resourceSets[0].resources[0].point.coordinates;
      let lat = latlng[0];
      let lng = latlng[1];

      if (lat < 32.534156 || lat > 42.009518 || lng < -124.409591 || lng > -114.131211) {
        return Swal.fire({
          icon: 'error',
          text: 'This location seems to be outside of California. Did you include a city name and zip code? Please try again',
        });
      }

      getLayerNamesAtLatLng(lat, lng);
    });
  })


}

///////////////////////////////////////////////////////////////////////////////////
// NAMED FUNCTIONS
///////////////////////////////////////////////////////////////////////////////////

function getLayerNamesAtLatLng(lat, lng) {

  if (MAP.hasLayer(PLACEMARKER)) MAP.removeLayer(PLACEMARKER);
  PLACEMARKER = L.marker([lat,lng]).addTo(MAP);

  let results = [];
  Object.keys(LAYERS).forEach(function(layer) {
    let result = leafletPip.pointInLayer([lng, lat], LAYERS[layer].layer);
    result.forEach(function(r) {
      let label = LAYERS[layer].label;
      let place = r.feature.properties[LAYERS[layer].field];
      let slug = `<b>${label}</b>: ${place}`;
      results.push(slug);
    });
    if (results.length) {
      Swal.fire({
        title: 'Places found',
        icon: 'info',
        html: results.join('<br>'),
        confirmButtonText: 'OK',
      });
    } else {
      MAP.removeLayer(PLACEMARKER);
      Swal.fire({
        icon: 'error',
        text: 'Nothing found!',
        confirmButtonText: 'OK',
      });
    }
  });
  return;
}
